import { render, staticRenderFns } from "./yzzlList.vue?vue&type=template&id=ed814fd2&scoped=true"
import script from "./yzzlList.vue?vue&type=script&lang=js"
export * from "./yzzlList.vue?vue&type=script&lang=js"
import style0 from "./yzzlList.vue?vue&type=style&index=0&id=ed814fd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed814fd2",
  null
  
)

export default component.exports